import { useEffect, useState, useCallback } from 'react';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {
  AllTemplatesForBuilderQuery,
  TemplateTypeEnum,
  useAllTemplatesForBuilderQuery,
} from '@/__generated__/graphql';
import { abyssColors } from '@/theme/colors';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { containedButtonStyle } from '@/theme';
import { FormTypes } from './constants';

type GenericTemplateProps = {
  structureId: string;
  selectedTemplateType: string;
};

export const GenericTemplate = ({ structureId, selectedTemplateType }: GenericTemplateProps) => {
  const [selectedTemplate, setSelectedTemplate] =
    useState<AllTemplatesForBuilderQuery['allTemplates'][0]>();

  const { data, loading } = useAllTemplatesForBuilderQuery({
    variables: {
      structureId,
      type:
        Object.values(TemplateTypeEnum).find(
          (value) => value.toString() === selectedTemplateType
        ) ?? TemplateTypeEnum.Structure,
    },
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    setSelectedTemplate(data?.allTemplates[0]);
  }, [data?.allTemplates]);

  const addNewTemplate = useCallback(() => {}, []);

  if (loading) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: 'rgba(255,255,255,0.6)',
          pt: 20,
          pb: 20,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: '8px',
        }}
      >
        <img
          src="/assets/abyss_fabric_mini_logo_black.svg"
          style={{ height: '6.4rem' }}
          alt="abyss-logo"
        />
      </Stack>
    );
  }
  return (
    <Container>
      {selectedTemplate ? (
        <Stack direction="row" gap={2} sx={{ pt: 2 }}>
          <Stack gap={3} direction="column">
            <Typography variant="h6">{selectedTemplate.name}</Typography>
            {selectedTemplate?.fields.map((field) => (
              <Typography key={field.id} variant="body1">
                {field.name}
              </Typography>
            ))}
          </Stack>
          <Button
            sx={{ ...containedButtonStyle, ml: 'auto' }}
            startIcon={<AddCircleIcon />}
            variant="contained"
            onClick={addNewTemplate}
          >
            Add New Template
          </Button>
        </Stack>
      ) : selectedTemplateType === FormTypes.RiskConfiguration ? (
        <></>
      ) : (
        <Box
          sx={{
            pt: 20,
            pb: 20,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            borderRadius: '8px',
          }}
        >
          <InfoOutlinedIcon sx={{ color: abyssColors.primary[400], fontSize: '6rem' }} />
          <Typography
            variant="h6"
            fontWeight={500}
            sx={{
              color: abyssColors.primary[400],
              whiteSpace: 'nowrap',
              mt: 1,
            }}
          >
            No Template Found
          </Typography>
        </Box>
      )}
    </Container>
  );
};
